import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";
import { useThemeStore, Theme } from "../hooks/useTheme";

const THEMES: { value: Theme; label: string }[] = [
  { value: "dark",           label: "🌙 Dark" },
  { value: "light",          label: "☀️ Light" },
  { value: "midnight",       label: "🌌 Midnight" },
  { value: "high-contrast",  label: "⚡ High Contrast" },
];

export default function Settings() {
  const navigate = useNavigate();
  const { email, role, clearAuth } = useAuthStore();
  const { theme, setTheme } = useThemeStore();

  return (
    <div style={{ maxWidth: 480, display: "flex", flexDirection: "column", gap: 20 }}>
      <h1 style={{ fontSize: 20, fontWeight: 900 }}>⚙️ Settings</h1>

      <div className="card" style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        <div style={{ fontWeight: 700 }}>Account</div>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13 }}>
          <span style={{ color: "var(--text-muted)" }}>Email</span>
          <span>{email}</span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13 }}>
          <span style={{ color: "var(--text-muted)" }}>Role</span>
          <span style={{ textTransform: "capitalize" }}>{role}</span>
        </div>
        <button className="btn btn-danger" style={{ alignSelf: "flex-start" }}
          onClick={() => { clearAuth(); navigate("/login", { replace: true }); }}>
          Sign Out
        </button>
      </div>

      <div className="card" style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        <div style={{ fontWeight: 700 }}>Theme</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
          {THEMES.map((t) => (
            <button key={t.value} onClick={() => setTheme(t.value)}
              style={{
                padding: "10px 14px", borderRadius: 8, fontSize: 13, fontWeight: 600,
                border: `1px solid ${theme === t.value ? "var(--accent)" : "var(--border)"}`,
                background: theme === t.value ? "var(--accent-dim)" : "var(--surface2)",
                color: "var(--text)",
              }}>
              {t.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
